export const foodAnalyzerService = async (foodItem, setButtonText, setButtonDisabled) => {
    const token = localStorage.getItem("authToken"); 

    if (!token) {
        throw new Error("No auth token found");
    }

    const foodInput = {
        foodItem,
    };

    setButtonText("Analyzing...");
    setButtonDisabled(true);

    try {
        const response = await fetch(`/api/v1/food-analyzer`, { 
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(foodInput),
        });
        if (!response.ok) {
            throw new Error(`API Error: ${response.statusText}`);
        }
        
        const apiResponse = await response.json();
        // console.log("Food Safety Response:", apiResponse);

        setButtonText("Analysis Complete!");
        return apiResponse; 

    } catch (error) {
        // console.error("Failed to check food safety:", error);
        setButtonText("Error Checking");
    } finally {
        setButtonDisabled(false);
    }
};